import React, {useEffect, useState} from 'react'
import {Button, Form, InputNumber, Modal, Input} from "antd";
import {updateScrap} from "../../services/serviceScrap";


const {TextArea} = Input

const ScrapEdit = ({record, updater}) => {
    const [form] = Form.useForm()
    const [showModal, setShowModal] = useState(false)
    const [stockId, setStockId] = useState()
    const [prodId, setProdId] = useState()

    useEffect(() => {
        setProdId(record.prodInfo.id)
        setStockId(record.stockInfo.id)
    }, [record])

    const handleEditClick = () => setShowModal(!showModal)
    const modalCloser = () => setShowModal(!showModal)
    const handleSubmit = () => {
        const {
            quantity,
            note
        } = form.getFieldsValue()

        let requestObj = {
            quantity: quantity,
            note: note,
            production: {
                id: prodId
            },
            stock: {
                id: stockId
            },
            id: record.id
        }

        updateScrap(requestObj)
            .then(() => {
                modalCloser()
                updater()
            })
    }

    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleEditClick}
            >
                Güncelle
            </Button>

            <Modal
                open={showModal}
                title={'Hurda Giriş Güncelle'}
                closable={false}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={"primary"}
                        onClick={() => form.submit()}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={modalCloser}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelAlign={'left'}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                >
                    <Form.Item
                        name={'quantity'}
                        label={'Miktar'}
                        rules={[
                            {
                                required: true,
                                type: 'number',
                                min: 1,
                                message: 'Miktar Alanı Boş Bırakılamaz ve En az 1 Olmalıdır'
                            }
                        ]}
                        initialValue={record.quantity}
                    >
                        <InputNumber min={1} step={0.1}/>
                    </Form.Item>
                    <Form.Item
                        name={'note'}
                        label={'Not'}
                        rules={[
                            {max: 300, message: 'Not Alanı En Fazla 300 Karakter Olabilir'}
                        ]}
                        initialValue={record.note}
                    >
                        <TextArea/>
                    </Form.Item>
                </Form>
            </Modal>


        </React.Fragment>
    )
}
export default ScrapEdit